(function () {
    'use strict';

    if ($('.widgets-form').length === 0) return;

    var $form = $('.widgets-form form');

    var $country = $form.find('input#country');
    var $location = $form.find('input#location');
    var countrySelected = $country.val().length > 0;

    $.ajax({
        url: '/api/countries',
        method: 'GET',
    })
        .done(function (results) {
            loadCountriesDropdown(results);
        })
        .fail(function () {
            console.log('error');
        });

    $('.widgets-form .widget-code-block textarea').on('focus', function (e) {
        var $this = $(this);

        $this.select();

        // Work around Chrome's little problem
        $this.mouseup(function () {
            // Prevent further mouseup intervention
            $this.unbind('mouseup');

            return false;
        });
    });

    function loadCountriesDropdown(countries) {
        var data = $.map(countries, function (country, key) {
            return {
                id: country.id,
                text: country.name,
            };
        });

        if (countrySelected) {
            getLocationsData($country.val());
        }

        $country
            .select2({
                data: data,
                allowClear: true,
                placeholder: {
                    id: 0,
                    text: 'Choose a country',
                },
            })
            .on('change', function (e) {
                var country = $(e.target).val();

                getLocationsData(country);
            });
    }

    function getLocationsData(country) {
        $.ajax({
            url: '/api/locations',
            data: { country_id: country },
            method: 'GET',
        })
            .done(function (results) {
                loadLocationsDropdown(results);
            })
            .error(function () {
                console.log('error');
            });
    }

    function loadLocationsDropdown(locations) {
        var data = $.map(locations, function (location, key) {
            return {
                id: location.id,
                text: location.name,
            };
        });

        $location
            .select2({
                data: data,
                allowClear: true,
                placeholder: {
                    id: 0,
                    text: 'Choose a location',
                },
            })
            .removeAttr('disabled');
    }
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/widgets/form.js